import React, { useState } from 'react';
import { XIcon, Trash2Icon } from 'lucide-react';
import { ConditionStatus, STATUSES, STATUS_COLORS } from '../types/condition';
type BulkActionsToolbarProps = {
  selectedCount: number;
  onClearSelection: () => void;
  onBulkUpdateStatus: (status: ConditionStatus) => void;
  onBulkDelete: () => void;
};
export function BulkActionsToolbar({
  selectedCount,
  onClearSelection,
  onBulkUpdateStatus,
  onBulkDelete
}: BulkActionsToolbarProps) {
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  if (selectedCount === 0) return null;
  const handleDelete = () => {
    onBulkDelete();
    setShowDeleteConfirm(false);
  };
  return <div className="fixed bottom-0 left-0 right-0 z-30 animate-slide-up" data-id="element-43">
      <div className="bg-gray-900 border-t border-gray-700 shadow-2xl" data-id="element-44">
        <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-45">
          <div className="flex items-center justify-between" data-id="element-46">
            {/* Left: Selection Info */}
            <div className="flex items-center gap-4" data-id="element-47">
              <div className="flex items-center gap-2" data-id="element-48">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-sm font-semibold" data-id="element-49">
                  {selectedCount}
                </div>
                <span className="text-white font-medium" data-id="element-50">
                  {selectedCount}{' '}
                  {selectedCount === 1 ? 'condition' : 'conditions'} selected
                </span>
              </div>

              <button onClick={onClearSelection} className="text-gray-400 hover:text-white transition-colors" aria-label="Clear selection" data-id="element-51">
                <XIcon className="w-5 h-5" data-id="element-52" />
              </button>
            </div>

            {/* Right: Actions */}
            <div className="flex items-center gap-3" data-id="element-53">
              {/* Change Status */}
              <div className="relative" data-id="element-54">
                <button onClick={() => setIsStatusOpen(!isStatusOpen)} className="
                    px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg
                    hover:bg-blue-700 transition-colors
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 focus:ring-offset-gray-900
                    flex items-center gap-2
                  " data-id="element-55">
                  Change Status
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-56">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-57" />
                  </svg>
                </button>

                {isStatusOpen && <>
                    <div className="fixed inset-0 z-10" onClick={() => setIsStatusOpen(false)} data-id="element-58" />
                    <div className="absolute bottom-full mb-2 right-0 z-20 w-48 bg-white border border-gray-200 rounded-lg shadow-xl" data-id="element-59">
                      {STATUSES.map(status => {
                    const colors = STATUS_COLORS[status];
                    return <button key={status} onClick={() => {
                      onBulkUpdateStatus(status);
                      setIsStatusOpen(false);
                    }} className="
                              w-full px-4 py-2.5 text-sm text-left hover:bg-gray-50 transition-colors
                              first:rounded-t-lg last:rounded-b-lg
                            " data-id="element-60">
                            <span className={colors.text} data-id="element-61">{status}</span>
                          </button>;
                  })}
                    </div>
                  </>}
              </div>

              {/* Delete */}
              {!showDeleteConfirm ? <button onClick={() => setShowDeleteConfirm(true)} className="
                    px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg
                    hover:bg-red-700 transition-colors
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 focus:ring-offset-gray-900
                    flex items-center gap-2
                  " data-id="element-62">
                  <Trash2Icon className="w-4 h-4" data-id="element-63" />
                  Delete
                </button> : <div className="flex items-center gap-2" data-id="element-64">
                  <span className="text-sm text-gray-300" data-id="element-65">
                    Delete {selectedCount}{' '}
                    {selectedCount === 1 ? 'condition' : 'conditions'}?
                  </span>
                  <button onClick={handleDelete} className="px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded hover:bg-red-700 transition-colors" data-id="element-66">
                    Confirm
                  </button>
                  <button onClick={() => setShowDeleteConfirm(false)} className="px-3 py-1.5 text-sm font-medium text-gray-300 hover:text-white transition-colors" data-id="element-67">
                    Cancel
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}